import { writable } from "svelte/store";

// Right-panel collapse state. Module-level so it survives the panel unmounting
// on a tab switch.

/** "Not in FrameX" section — collapsed by default, sticky once opened. */
export const notInFrameXExpanded = writable(false);

/**
 * Collapsed Frames-list group headers, `{ "<groupBy>:<groupKey>" -> true }`.
 * A missing key means expanded, so only an explicit collapse is remembered.
 * Keys are namespaced by mode: a sheet and a scope both named "A-101" are
 * different groups and must collapse independently.
 */
export const collapsedFrameGroups = writable({});

export function frameGroupKey(groupBy, key) {
  return `${groupBy}:${key}`;
}

export function toggleFrameGroup(groupBy, key) {
  const id = frameGroupKey(groupBy, key);
  collapsedFrameGroups.update((collapsed) => {
    const next = { ...collapsed };
    if (next[id]) delete next[id];
    else next[id] = true;
    return next;
  });
}

/**
 * Collapse/expand many keys at once (Collapse all). Touches only this mode's
 * keys, so the other mode survives a round trip through the Group by dropdown.
 */
export function setFrameGroupsCollapsed(groupBy, keys, collapsed) {
  collapsedFrameGroups.update((state) => {
    const next = { ...state };
    for (const key of keys || []) {
      const id = frameGroupKey(groupBy, key);
      if (collapsed) next[id] = true;
      else delete next[id];
    }
    return next;
  });
}
